export default class PublisherRegistrationService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    utils,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.$q = $q;
    this.utils = utils;
    this.ngAuthSettings = ngAuthSettings;
  }

  createPRP(accountId, prp, setAsDefault) {
    var url = this.#serviceBaseUrl(accountId);
    var newPRP = this._initPRPCreateRequest(prp, setAsDefault);

    return this.$http.post(url, newPRP).then(this.utils.rejectPromiseOnAPIError);
  }

  updatePRP(accountId, prp) {
    var url = this.#serviceBaseUrl(accountId, prp.id);
    var newPRP = this._initPRPPatchRequest(prp);

    return this.$http.patch(url, newPRP).then(this.utils.rejectPromiseOnAPIError);
  }

  getDefaultPRP(accountId) {
    return this.getPRPById(accountId, 'default');
  }

  getPRPById(accountId, prpId) {
    var url = this._serviceBaseUrl(accountId, prpId);
    return this.$http.get(url).then(this.utils.rejectPromiseOnAPIError);
  }

  getPublicPRPDetails(prpId) {
    var url = this._servicePublicBaseUrl(prpId);
    return this.$http.get(url);
  }

  submitPRPForm(prpId, formData) {
    var url = this._servicePublicBaseUrl(prpId);
    return this.$http.post(url, formData).then(this.utils.rejectPromiseOnAPIError);
  }

  #servicePublicBaseUrl(prpId) {
    return this.ngAuthSettings.apiServiceBaseUri + '/PublisherSignup/' + prpId;
  }

  #serviceBaseUrl(accountId, prpId) {
    var result = this.ngAuthSettings.apiServiceBaseUri + accountId + '/publisher-registration';

    if (prpId) {
      result += '/' + prpId;
    }

    return result;
  }

  _initPRPPatchRequest(prp) {
    var result = {
      name: prp.name || '',
      enabled: !!prp.enabled,
      description: prp.description || '',
      contactEmail: prp.contactEmail || '',
      requireAgreementToTerms: !!prp.requireAgreementToTerms,
      customPublisherFields: prp.customPublisherFields || null,
      termsAndConditions: prp.termsAndConditions,
      isTermsAndConditionsURL: prp.isTermsAndConditionsURL,
    };

    return result;
  }

  _initPRPCreateRequest(prp, setAsDefault) {
    var result = {
      name: prp.name || '',
      enabled: !!prp.enabled,
      description: prp.description || '',
      contactEmail: prp.contactEmail || '',
      requireAgreementToTerms: !!prp.requireAgreementToTerms,
    };

    if (prp.customPublisherFields) {
      result.customPublisherFields = prp.customPublisherFields;
    }

    if (setAsDefault === true) {
      result.setAsDefault = true;
    }

    if (prp.requireAgreementToTerms) {
      result.termsAndConditions = prp.termsAndConditions;
      result.isTermsAndConditionsURL = prp.isTermsAndConditionsURL;
    }

    return result;
  }
}